<template>
	<div class="row">

		<div class="tabbed-view-mobile col-12">
			<div class="flex flex-row justify-between mb-2">
				<button class="btn btn-sm btn-outline-secondary" :class="{'disabled': !hasPrev()}" @click="prev()"><b-icon icon="chevron-left"></b-icon>{{ $t('previous') }}</button>
				<button class="btn btn-sm btn-outline-secondary" @click="toggleMobileMenu"><b-icon :icon="getMenuIcon()"></b-icon></button>
				<button class="btn btn-sm btn-outline-secondary" :class="{'disabled': !hasNext()}" @click="next()">{{ $t('next') }}<b-icon icon="chevron-right"></b-icon></button>
			</div>

			<ul class="popout-menu mt-4" :class="{'popout-menu--active': menuActive}">
				<li class="mb-4" v-for="(tab, index) in tabs" :key="index">
					<div @click="selectTab(index)">
						<div
							:class="
								index === selectedIndex ? 'tab-nav-icon tab-nav-icon--active' : 'tab-nav-icon'
							"
						>
							<div class="tab-nav-icon-inner"></div>
						</div>
						{{ tab.title }}
					</div>
				</li>
			</ul>
		</div>

		<div class="col-xs-12 col-md-9">
			<div class="tabbed-view-main">
				<template>
					<slot></slot>
				</template>
				<button class="btn btn-outline-secondary mb-4" @click="prev()" v-if="hasPrev()"><b-icon icon="chevron-left"></b-icon>{{ $t('previous') }}</button>
				<button class="btn btn-success mb-4 float-right" @click="next()" v-if="hasNext()">{{ $t('next') }}<b-icon icon="chevron-right"></b-icon></button>
				<!--
				<div v-if="!hasNext()" class="float-right">
					<button class="btn btn-outline-secondary mb-2 ml-2" @click="submitFormResponse(false)" v-if="showSaveDraftBtn">{{ $t('save-draft') }}</button>
					<button class="btn btn-success mb-2 ml-2" v-if="showCompleteBtn" @click="formresponse.formresponse_completed=1; submitFormResponse()">{{ $t('submit-form') }}</button>
					<button class="btn btn-success mb-2 ml-2" v-if="showSignOffBtn" @click="formresponse.formresponse_signedoff=1; submitFormResponse()">{{ $t('sign-off') }}</button>
				</div>
				-->
			</div>
		</div>

		<div class="tabbed-view-sidebar col-md-3">
			<ul class="list-bare tab-nav">
				<li v-for="(tab, index) in tabs" :key="index">
					<button
						class="btn tab-nav-item"
						@click="selectTab(index)"
						:class="index == selectedIndex?'tab-nav-item--active':''"
					>
						<div
							class="tab-nav-icon"
							:class="index === selectedIndex?'tab-nav-icon--active':''"
						>
							<div class="tab-nav-icon-inner"></div>
						</div>
						<div class="tab-nav-caption">{{ tab.title }}</div>
					</button>
				</li>
			</ul>
		</div>

	</div>
</template>

<script>
export default {
	data() {
		return {
			selectedIndex: 0, // the index of the selected tab,
			tabs: [], // all of the tabs
			menuActive: false
		};
	},
	created() {
		this.tabs = this.$children;
	},
	mounted() {
		this.selectTab(0);
		this.$emit('selectedIndexChanged', this.hasNext());
	},
	updated() {

	},
	watch: {
    selectedIndex: {
      handler() {
        this.$emit('selectedIndexChanged', this.hasNext());
      }
    }
  },
	methods: {
		selectTab(i) {
			this.selectedIndex = i;
			// loop over all the tabs
			this.tabs.forEach((tab, index) => {
				tab.isActive = index === i;
			});
			this.menuActive = false;
		},
		hasPrev(){
			return this.selectedIndex > 0;
		},
		prev(){
			if(this.hasPrev()){
				this.selectTab(this.selectedIndex-1);
			}
		},
		hasNext(){
			if(this.tabs.length>0){
				return this.selectedIndex+1 < this.tabs.length
			}	
		},
		next(){
			if(this.hasNext()){
				this.selectTab(this.selectedIndex+1);
			}
		},
		toggleMobileMenu() {
			this.menuActive = !this.menuActive;
		},
		getMenuIcon() {
			if (this.menuActive) {
				return "chevron-up";
			}

			return "chevron-down";
		}
	}
	// mounted() {
	//   this.tabs = this.$children.map((item, index) => ({
	//     name: item.$attrs.name,
	//     isActive: index === 0,
	//     isComplete: false
	//   }));
	// }
};
</script>
